<template>
  <div>
    <PageAllow controller="Purchases" action="getInventoryReference" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1" v-if="search_type == 1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="orderDatetimeRadios"
                removeIcon
              />
            </v-row>
            <v-row dense align="center" class="pa-1" v-if="search_type == 2">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="stockOrderDatetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 -->
              <v-btn
                small
                color="print"
                dark
                @click="exports()"
              >
                <v-icon x-small class="px-1">fa-file-export</v-icon>
                {{ $t("Export.export", [$t("PurchaseInventory.title")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategoriesWithDescendants v-model="categorySelecteds" />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials v-model="materialSelected"/>
                </v-col>
                <!-- 供应商 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherSupplier v-model="supplierSelected" />
                </v-col>
                <!-- 仓库 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStocks v-model="stocksSelected" />
                </v-col>
                <!-- 配送线路 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistributionUser v-model="distributionUserSelected" />
                </v-col>
                <!-- 采购员 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherPurchaseUser v-model="accountUserSelected" :stockIds="options.stock_ids"/>
                </v-col>
                <v-col cols="12" class="d-flex mt-2">
                  <v-col cols="12" sm="6" md="4">
                    <!-- 统计类型 -->
                    <SearcherSingleStatus
                      :items="$consts.searchTypes"
                      mandatory
                      :label="$t('PurchaseInventory.searchTypes.title')"
                      v-model="search_type"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <!-- 支付状态 -->
                    <SearcherStatus
                      v-model="options.pay_flgs"
                      :items="$consts.bill.pay_flgs"
                      :label="$t('Bill.payFlgs.title')"
                    />
                  </v-col>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="materials"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.unconfirm_num="{ item }">
              {{ item.unconfirm_num | formatTwoDot }}
            </template>
            <template v-slot:item.num_sum="{ item }">
              {{ item.num_sum | formatTwoDot }}
            </template>
            <template v-slot:item.total_sum="{ item }">
              {{ item.total_sum | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherSupplier from "@/components/plugins/SearcherSupplier";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import SearcherDistributionUser from "@/components/plugins/SearcherDistributionUser";
import SearcherPurchaseUser from "@/components/plugins/SearcherPurchaseUser";
import SearcherSingleStatus from "@/components/plugins/SearcherSingleStatus";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import Purchases from "@/api/purchases";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  expect_time_from: "",
  expect_time_to: "",
  search_type: 1,
  category_codes: [],
  pay_flgs: [1,2,3],
  material_ids: [],
  supplier_id: null,
  stock_ids: [],
  distribution_user_id: null,
  account_user_id: null
};
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherMaterialCategoriesWithDescendants,
    SearcherMaterials,
    SearcherSupplier,
    SearcherStocks,
    SearcherDistributionUser,
    SearcherPurchaseUser,
    SearcherSingleStatus,
    SearcherStatus,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.purchases"),
        disabled: false,
        href: "/purchases",
      },
      {
        text: i18n.t("Nav.PurchaseInventory"),
        disabled: true,
      },
    ],

    orderDatetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Order.Fields.created_time"),
      },
      {
        key: "expect",
        text: i18n.t("Order.Fields.expect_date"),
      },
    ],
    stockOrderDatetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Order.Fields.created_time"),
      },
    ],

    headers() {
      let headers = [
        {
          text: i18n.t("PurchaseInventory.Fields.category_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("PurchaseInventory.Fields.material_code"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("PurchaseInventory.Fields.material_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "material_name",
        },
        {
          text: i18n.t("PurchaseInventory.Fields.unit"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "unit",
        },
      ];
      if (this.search_type == 1) {
        if (this.stocksSelected.length == 0) {
          headers.push(
            {
              text: i18n.t("PurchaseInventory.Fields.unconfirm_num"),
              align: "center",
              sortable: false,
              class: "text-no-wrap",
              value: "unconfirm_num",
            },
            {
              text: i18n.t("PurchaseInventory.Fields.confirm_num_sum"),
              align: "center",
              sortable: false,
              class: "text-no-wrap",
              value: "num_sum",
            }
          )
        }else {
          headers.push({
            text: i18n.t("PurchaseInventory.Fields.num_sum"),
            align: "center",
            sortable: false,
            class: "text-no-wrap",
            value: "num_sum",
          })
        }
      } else {
        headers.push({
          text: i18n.t("PurchaseInventory.Fields.num_sum"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "num_sum",
        })
      }
      return headers
    },

    ...mapState(["loading", "stickTableCols"]),
  },

  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("purchase-inventory-options")
        ? sessionStorage.getItem("purchase-inventory-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    search_type: 1,
    categorySelecteds: [],
    materialSelected: [],
    supplierSelected: null,
    stocksSelected: [],
    distributionUserSelected: null,
    accountUserSelected: null,
    materials: [],
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("purchase-inventory", ["categorySelecteds", "materialSelected", "supplierSelected", "stocksSelected", "distributionUserSelected", "accountUserSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "categorySelecteds":
                this.categorySelecteds = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
              case "supplierSelected":
                this.supplierSelected = selected.value;
                break;
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "distributionUserSelected":
                this.distributionUserSelected = selected.value;
                break;
              case "accountUserSelected":
                this.accountUserSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    resetSearch() {
      this.categorySelecteds = [];
      this.materialSelected = [];
      this.supplierSelected = null;
      this.stocksSelected = [];
      this.distributionUserSelected = null;
      this.accountUserSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {

      });
    },
    getMaterialsFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      Purchases.getInventoryReference(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.materials;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    exports() {
      let options = JSON.parse(JSON.stringify(this.options));
      Purchases.inventoryReferenceExport(options);
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getMaterialsFromAPI();
        sessionStorage.setItem(
          "purchase-inventory-options",
          JSON.stringify(this.options)
        );
      },
    },
    search_type: {
      handler() {
        this.options.search_type = this.search_type;
        this.options.datetimeRadioSelected = 'created';
        this.options.created_time_from =  new Date(new Date().getTime() - 30 * 24 * 3600 * 1000).toISOString().substr(0, 10) + " 00:00:00";
        this.options.created_time_to = new Date().toISOString().substr(0, 10) + " 23:59:59";
        this.options.expect_time_from = '';
        this.options.expect_time_to = '';
        this.stocksSelected = [];
        this.distributionUserSelected = null;
        this.accountUserSelected = null;
      }
    },
    categorySelecteds: {
      handler() {
        this.options.category_codes = this.categorySelecteds
          ? this.categorySelecteds.map((category) => {
              return category.code;
            })
          : "";
        sessionStorage.setItem(
          "purchase-inventory-categorySelecteds",
          JSON.stringify(this.categorySelecteds)
        );
      },
    },
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : [];
        sessionStorage.setItem(
          "purchase-inventory-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.map((e) => {
              return e.id;
            })
          : [];
        sessionStorage.setItem(
          "purchase-inventory-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    distributionUserSelected: {
      handler() {
        this.options.distribution_user_id = this.distributionUserSelected
          ? this.distributionUserSelected.id
          : null;
        sessionStorage.setItem(
          "purchase-inventory-distributionUserSelected",
          JSON.stringify(this.distributionUserSelected)
        );
      },
    },
    accountUserSelected: {
      handler() {
        this.options.account_user_id = this.accountUserSelected
          ? this.accountUserSelected.id
          : null;
        sessionStorage.setItem(
          "purchase-inventory-accountUserSelected",
          JSON.stringify(this.accountUserSelected)
        );
      }
    },
    supplierSelected: {
      handler() {
        this.options.supplier_id = this.supplierSelected
          ? this.supplierSelected.id
          : "";
        sessionStorage.setItem(
          "purchase-inventory-supplierSelected",
          JSON.stringify(this.supplierSelected)
        );
      },
    },
  },
};
</script>